module.exports = __webpack_public_path__ + "img/tool-appset.ec76f57.jpg";